import React from 'react'

import Select from '@/lib/components/Select/EnhancedSyncSelect/EnhancedSyncSelect'
import { SelectProps } from '@/lib/components/Select/EnhancedSyncSelect/types'
import { splitProps } from '@/utils/collections'

import FormField, { FormlessFormField } from '../FormField'
import { FormFieldProps } from '../types'

export default class SelectFormField<T> extends React.PureComponent<
	FormFieldProps &
		Omit<SelectProps<T>, 'onChange'> & {
			formless?: boolean
		}
> {
	render() {
		const fieldProps = { ...this.props }

		const inputProps = splitProps(fieldProps, [
			'valueKey',
			'labelKey',
			'options',
			'allowEmpty',
			'isMulti',
			'placeholder',
			'clearable',
			'formatOptionLabel',
			'isNumeric',
			'autoFocus',
			'openMenuOnFocus',
			'onMenuOpen',
			'onMenuClose',
			'refInput',
			'onFocus',
			'onBlur',
			'onInputChange',
			'components',
			'isDisabled',
			'testId',
		]) as SelectProps<Record<string, any>>

		const FF = this.props.formless ? FormlessFormField : FormField

		return (
			<FF {...fieldProps}>
				<Select {...inputProps} />
			</FF>
		)
	}
}
